import type { ColumnSort } from '@plato/ui/components/data-table';
import { useMemo } from 'react';
import type { ExplorerSort, ExplorerSortBy } from '../../../server/utils/explorer-utils.ts';
import { ExplorerSortOrder } from '../../../server/utils/explorer-utils.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

export function useExplorerSorting(
    sortingFilter: ExplorerSort | null,
    setSortingFilter: (sortingFilter: ExplorerSort | null) => void,
) {
    const sendEvent = useAnalytics();

    const sorting = useMemo((): ColumnSort<ExplorerSortBy> | undefined => {
        if (sortingFilter) {
            return { by: sortingFilter.field, direction: sortingFilter.direction };
        } else {
            return undefined;
        }
    }, [sortingFilter]);

    const sortChangedInInterface = (sort: ColumnSort<ExplorerSortBy> | undefined): void => {
        if (sort) {
            setSortingFilter({ field: sort.by, direction: sort.direction });
            sendEvent('sales_report_sort_used', {
                column: sort.by,
                direction: sort.direction === ExplorerSortOrder.DESC ? 'DESC' : 'ASC',
            });
        } else {
            setSortingFilter(null);
        }
    };

    return { sorting, sortChangedInInterface };
}
